/* @ngInject */
function AnalyticsDataFrameCardController (
  $rootScope,
  $scope,
  $state,
  $translate,
  $timeout,
  AnalyticsService,
  $attrs,
  $window,
  Utils
) {
  $scope.flags = {
    loading: true,
    statusCard: '',
    hasError: false,
    icon: '',
    maxRate: 5
  }

  $scope.comparativeDate = ''
  $scope.tooltipComparativeDate = ''
  $scope.tooltipPosition = 'bottom'

  $scope.params = {
    start: '',
    end: ''
  }

  const api = {
    _loadDataFrameData,
    _successGetResponse,
    _errorGetResponse,
    _finallyGetResponse,
    _getPercentageFromTotal,
    _formatLastPeriodTooltip,
    _getLastPeriod,
    _formatDate,
    _insertParamsAndLoadData,
    _getUserLocale,
    _successGetUserLocale,
    _parseData,
    _getTooltipPosition
  }

  const slug = $state.params.slug || $scope.slug

  this.getApi = () => api

  activate()

  function activate () {
    $window.addEventListener('resize', Utils.debounce(api._getTooltipPosition))
    $timeout(api._getTooltipPosition, 100, true)
    api._getUserLocale()
  }

  $scope.$watchCollection('filterParams', api._insertParamsAndLoadData)

  $scope.loadDataFrameData = () => {
    return api._loadDataFrameData(slug, $scope.data.id)
  }

  function _getTooltipPosition () {
    const tooltip = $attrs.$$element.find('.data-frame-card-tooltip-about')[0]
    const tooltipLeftPosition = tooltip.getBoundingClientRect().left
    const windowWidth = $window?.innerWidth
    const isMoreThan70Percent = (tooltipLeftPosition / windowWidth) * 100 > 70
    const isLessThan30Percent = (tooltipLeftPosition / windowWidth) * 100 < 30

    if (isMoreThan70Percent) {
      $scope.tooltipPosition = 'left'
      return
    }

    if (isLessThan30Percent) {
      $scope.tooltipPosition = 'right'
      return
    }

    $scope.tooltipPosition = 'bottom'
  }

  /**
   * This method call the method for get data of card
   *
   * @param {String} paramsSlug
   * @param {Number} dataFrameId
   */
  function _loadDataFrameData (paramsSlug, dataFrameId) {
    $scope.flags.loading = true
    $scope.loadingDataFrames.card = true
    $scope.flags.hasError = false

    AnalyticsService.getDataFrameDataFromId(paramsSlug, dataFrameId, $scope.params)
      .then(api._successGetResponse)
      .catch(api._errorGetResponse)
      .finally(api._finallyGetResponse)
  }

  /**
   * This method load the values when request is successful.
   *
   * check if exists data and added values to card, if not exists added empty values to card
   *
   * @param {object} response
   */
  function _successGetResponse (response) {
    const {
      data: {
        result
      }
    } = response
    const { total, previousPeriod } = result[0]
    const { totalFormatted, compareTotalPrevious } = api._parseData({ total, previousPeriod })

    if ($scope.data.params?.maxRate) {
      $scope.flags.maxRate = $scope.data.params.maxRate
    }

    $scope.dataCard = {
      totalNumbers: totalFormatted,
      compareTotalPrevious
    }
  }

  /**
   * This method show the error and added empty values for when request fails
   */
  function _errorGetResponse (error) {
    console.log({ error })

    $scope.flags.statusCard = ''
    $scope.dataCard = {
      totalNumbers: '0',
      compareTotalPrevious: '0'
    }

    $scope.flags.hasError = true
  }

  function _finallyGetResponse () {
    $scope.flags.loading = false
    $scope.loadingDataFrames.card = false
  }

  /**
   * This method is used to parse the total and previousPeriod values
   *
   * @param {String} total
   * @param {String} previousPeriod
   * @returns {Object} values parsed
   */
  function _parseData ({ total, previousPeriod }) {
    const parsedIntPreviousPeriod = parseInt(previousPeriod, 10)
    const parsedIntTotal = parseInt(total, 10)
    const parsedFloat = parseFloat(total)
    const percentageFormatted = parsedIntTotal / 100

    const getTotal = {
      TIME: Utils.getSimplifyingTime(total).formatted,
      INTEGER: parsedIntTotal.toLocaleString($scope.locale),
      PERCENTAGE: percentageFormatted.toLocaleString($scope.locale, { style: 'percent' }),
      RATE: parsedFloat === 0 ? '-' : parsedFloat
    }

    return {
      totalFormatted: getTotal[String($scope.data.unitType)],
      compareTotalPrevious: api._getPercentageFromTotal(parsedIntTotal, parsedIntPreviousPeriod)
    }
  }

  /**
   * This method is used to get the percentage from total
   *
   * example1: total = 100, previousPeriod = 50
   *
   * return 100%
   *
   * example2: total = 50, previousPeriod = 50
   *
   * return 0%
   *
   * example3: total = 8, previousPeriod = 0
   *
   * return N/A translation for en-US locale
   *
   * @param {Number} total
   * @param {Number} previousPeriod
   * @returns {String} percentage translated
   */
  function _getPercentageFromTotal (total, previousPeriod) {
    $scope.tooltipComparativeDate = ''

    const { unitType, isPositive } = $scope.data
    const unitTypes = {
      TIME: () => {
        const expression = Math.abs(total - previousPeriod)

        return {
          formatted: Utils.getSimplifyingTime(expression).formatted,
          expression,
          emptyText: '0m'
        }
      },
      INTEGER: () => {
        const expression = Math.abs((total - previousPeriod) / previousPeriod)

        return {
          formatted: expression.toLocaleString($scope.locale, { style: 'percent' }),
          expression,
          emptyText: '0%'
        }
      },
      PERCENTAGE: () => {
        const expression = Math.abs((total - previousPeriod) / 100)

        return {
          formatted: expression.toLocaleString($scope.locale, { style: 'percent' }),
          expression,
          emptyText: '0%'
        }
      },
      RATE: () => {
        const expression = Math.abs((total - previousPeriod) / previousPeriod)

        return {
          formatted: expression.toLocaleString($scope.locale, { style: 'percent' }),
          expression,
          emptyText: '0%'
        }
      }
    }

    const { startDateFormatted, endDateFormatted } = api._formatLastPeriodTooltip($scope.params)

    $scope.comparativeDate = $translate.instant('dataFrames.card.tooltips.comparativeDate', {
      startDateFormatted,
      endDateFormatted
    })

    if (total === previousPeriod || unitTypes[unitType]().expression < 0.005) {
      $scope.flags.statusCard = 'no-variation'
      $scope.flags.icon = 'arrow-right'
      $scope.tooltipComparativeDate = $translate.instant('dataFrames.card.tooltips.noVariation')

      return unitTypes[unitType]().emptyText
    }

    if (!total || !previousPeriod) {
      $scope.flags.statusCard = 'no-available'
      $scope.flags.icon = 'minus'
      $scope.tooltipComparativeDate = $translate.instant('dataFrames.card.tooltips.noAvailable')

      return $translate.instant('dataFrames.card.tooltips.noAvailableInitials')
    }

    if (total > previousPeriod) {
      $scope.flags.icon = 'arrow-up'
      $scope.flags.statusCard = isPositive ? 'positive' : 'negative'
    } else {
      $scope.flags.icon = 'arrow-down'
      $scope.flags.statusCard = isPositive ? 'negative' : 'positive'
    }

    if (unitType === 'INTEGER' && unitTypes[unitType]().expression >= 10) {
      return '999+%'
    }

    return unitTypes[unitType]().formatted
  }

  /**
   * This method formats the start and end dates to show in the tooltip
   *
   * @param {object} params
   */
  function _formatLastPeriodTooltip (params) {
    const { start, end } = params
    const { periodStart, periodEnd } = api._getLastPeriod(start, end)

    return {
      startDateFormatted: api._formatDate(periodStart),
      endDateFormatted: api._formatDate(periodEnd)
    }
  }

  /**
   * This method returns the last period the according to the start and end dates
   *
   * example: start is '2019-02-02T17:06:56.333Z' and end is '2019-02-20T17:06:56.333Z'
   *
   * total days between start and end is 19
   *
   * return {
   *  periodStart: '2019-01-14T17:06:56.333Z'
   *  periodEnd: '2019-02-01T17:06:56.333Z'
   * }
   *
   * @param {String} start
   * @param {String} end
   * @returns {object} { periodStart, periodEnd }
   */
  function _getLastPeriod (start, end) {
    const startDate = new Date(start)
    const endDate = new Date(end)

    const diffTime = Math.abs(startDate - endDate)
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24) + 1)

    return {
      periodStart: new Date(new Date(startDate).setDate(new Date(startDate).getDate() - diffDays)).toISOString(),
      periodEnd: new Date(new Date(startDate).setDate(new Date(startDate).getDate() - 1)).toISOString()
    }
  }

  /**
   * This method format the date for current locale.
   *
   * example: date is ISO String format and locale is en-US
   *
   * const date = '2019-03-01T17:06:56.333Z'
   *
   * return '03/01/2019'
   *
   * @param {String} date
   * @returns {String} Date formatted in ISO String format
   */
  function _formatDate (date) {
    return new Intl.DateTimeFormat($scope.locale).format(new Date(date))
  }

  /**
   * This method get new values from filter params and load the data
   *
   * Is called when filter params object is changed
   *
   * @param {object} newValues
   */
  function _insertParamsAndLoadData (newValues) {
    if (!newValues.filtersLoaded) return

    const { calendar: { start, end } } = newValues

    $scope.params = {
      ...$scope.params,
      ...newValues,
      start,
      end
    }

    api._loadDataFrameData(slug, $scope.data.id)
  }

  function _getUserLocale () {
    $rootScope.getUser().then(api._successGetUserLocale)
  }

  function _successGetUserLocale ({ locale }) {
    $scope.locale = locale
  }
}

export { AnalyticsDataFrameCardController }
